import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Primer ViewComponents is an implementation of the Primer Design System, using `}<a parentName="p" {...{
        "href": "https://github.com/github/view_component"
      }}>{`ViewComponent`}</a>{`.`}</p>
    <Note variant="warning" mdxType="Note">This library is under active pre-1.0 development. Breaking changes are likely in patch releases.</Note>
    <h2>{`Getting started`}</h2>
    <p>{`In your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode>{`, add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`gem "primer_view_components"
`}</code></pre>
    <p>{`In `}<inlineCode parentName="p">{`config/application.rb`}</inlineCode>{`, add `}<strong parentName="p">{`after the application definition`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`require "view_component"
require "primer/view_components"
`}</code></pre>
    <h3>{`CSS`}</h3>
    <p>{`Load CSS as a JS module into the pipeline. Update `}<inlineCode parentName="p">{`app/assets/config/manifest.js`}</inlineCode>{` with:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//= link primer_view_components.css
`}</code></pre>
    <p>{`Add it in your `}<inlineCode parentName="p">{`application.html.erb`}</inlineCode>{` in the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tag:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erb"
      }}>{`<%= stylesheet_link_tag("primer_view_components") %>
`}</code></pre>
    <h3>{`JS`}</h3>
    <p>{`Optionally, to add the JavaScript behaviours, in your `}<inlineCode parentName="p">{`application.html.erb`}</inlineCode>{` in the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tag add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erb"
      }}>{`<%= javascript_include_tag("primer_view_components") %>
`}</code></pre>
    <p>{`Or alternatively, you can install the `}<inlineCode parentName="p">{`@primer/view-components`}</inlineCode>{` npm package and in your JavaScript code add:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/view-components'
`}</code></pre>
    <p>{`You can also import only the components you need:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@primer/view-components/tab_container'
`}</code></pre>
    <h2>{`Usage`}</h2>
    <p>{`Render Primer ViewComponents in Rails templates:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-erb"
      }}>{`<%= render(Primer::Beta::Counter.new(count: 25)) %>
`}</code></pre>
    <h2>{`Dependencies`}</h2>
    <p>{`In addition to the dependencies declared in the `}<inlineCode parentName="p">{`gemspec`}</inlineCode>{`, Primer ViewComponents assumes the presence of `}<a parentName="p" {...{
        "href": "https://primer.style/css"
      }}>{`Primer CSS`}</a>{`.`}</p>
    <h2>{`More information`}</h2>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://github.com/primer/view_components"
      }}>{`primer/view_components repository`}</a>{` for more information about how to use and contribute to Primer ViewComponents. For component-specific documentation, check out the Rails section of component guidelines (example: `}<a parentName="p" {...{
        "href": "/components/action-list/rails"
      }}>{`ActionList`}</a>{`).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      